/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Annual_Payment_DescriptionInputs */

const en_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual payment`)
};

const id_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran tahunan`)
};

const ms_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bayaran tahunan`)
};

const ca_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagament anual`)
};

const cs_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roční platba`)
};

const da_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlig betaling`)
};

const de_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jährliche Zahlung`)
};

const et_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aastamakse`)
};

const es_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago anual`)
};

const fr_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement annuel`)
};

const hr_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godišnja pretplata`)
};

const it_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento annuale`)
};

const lv_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gada maksājums`)
};

const lt_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metinis mokėjimas`)
};

const hu_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éves kifizetés`)
};

const nl_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jaarlijkse betaling`)
};

const nb_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlig betaling`)
};

const pl_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płatność roczna`)
};

const pt_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento anual`)
};

const ro_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plata anuală`)
};

const sk_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ročná platba`)
};

const sl_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letno plačilo`)
};

const fi_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuosimaksu`)
};

const sv_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årlig betalning`)
};

const vi_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán hằng năm`)
};

const tr_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yıllık ödeme`)
};

const el_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ετήσια πληρωμή`)
};

const bg_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Годишно плащане`)
};

const ru_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежегодная оплата`)
};

const sr_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Годишње плаћање`)
};

const uk_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Річна підписка`)
};

const ka_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`წლიური გადახდა`)
};

const hi_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एनुअल पेमेंट `)
};

const th_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การชำระเงินรายปี`)
};

const ko_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`연간 결제`)
};

const zh_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按年支付`)
};

const zh_tw_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年度付款`)
};

const ja_annual_payment_description = /** @type {(inputs: Annual_Payment_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`年間の支払額`)
};

/**
* | output |
* | --- |
* | "Annual payment" |
*
* @param {Annual_Payment_DescriptionInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const annual_payment_description = /** @type {((inputs?: Annual_Payment_DescriptionInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Annual_Payment_DescriptionInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_annual_payment_description(inputs)
	if (locale === "ms") return ms_annual_payment_description(inputs)
	if (locale === "ca") return ca_annual_payment_description(inputs)
	if (locale === "cs") return cs_annual_payment_description(inputs)
	if (locale === "da") return da_annual_payment_description(inputs)
	if (locale === "de") return de_annual_payment_description(inputs)
	if (locale === "et") return et_annual_payment_description(inputs)
	if (locale === "es") return es_annual_payment_description(inputs)
	if (locale === "fr") return fr_annual_payment_description(inputs)
	if (locale === "hr") return hr_annual_payment_description(inputs)
	if (locale === "it") return it_annual_payment_description(inputs)
	if (locale === "lv") return lv_annual_payment_description(inputs)
	if (locale === "lt") return lt_annual_payment_description(inputs)
	if (locale === "hu") return hu_annual_payment_description(inputs)
	if (locale === "nl") return nl_annual_payment_description(inputs)
	if (locale === "nb") return nb_annual_payment_description(inputs)
	if (locale === "pl") return pl_annual_payment_description(inputs)
	if (locale === "pt") return pt_annual_payment_description(inputs)
	if (locale === "ro") return ro_annual_payment_description(inputs)
	if (locale === "sk") return sk_annual_payment_description(inputs)
	if (locale === "sl") return sl_annual_payment_description(inputs)
	if (locale === "fi") return fi_annual_payment_description(inputs)
	if (locale === "sv") return sv_annual_payment_description(inputs)
	if (locale === "vi") return vi_annual_payment_description(inputs)
	if (locale === "tr") return tr_annual_payment_description(inputs)
	if (locale === "el") return el_annual_payment_description(inputs)
	if (locale === "bg") return bg_annual_payment_description(inputs)
	if (locale === "ru") return ru_annual_payment_description(inputs)
	if (locale === "sr") return sr_annual_payment_description(inputs)
	if (locale === "uk") return uk_annual_payment_description(inputs)
	if (locale === "ka") return ka_annual_payment_description(inputs)
	if (locale === "hi") return hi_annual_payment_description(inputs)
	if (locale === "th") return th_annual_payment_description(inputs)
	if (locale === "ko") return ko_annual_payment_description(inputs)
	if (locale === "zh") return zh_annual_payment_description(inputs)
	if (locale === "zh-tw") return zh_tw_annual_payment_description(inputs)
	if (locale === "ja") return ja_annual_payment_description(inputs)
	return en_annual_payment_description(inputs)
});